import {translations} from 'presentation/translations-new';

const {weekDays} = translations['pt-br'].commons;

const WEEK_DAYS = {
	MONDAY: 'SEGUNDA FEIRA',
	TUESDAY: 'TERCA FEIRA',
	WEDNESDAY: 'QUARTA FEIRA',
	THURSDAY: 'QUINTA FEIRA',
	FRIDAY: 'SEXTA FEIRA',
	SATURDAY: 'SABADO',
	SUNDAY: 'DOMINGO',
};

const parseWeekDay = (weekDay: string) => {
	switch (weekDay) {
		case WEEK_DAYS.MONDAY:
			return weekDays.monday;
		case WEEK_DAYS.TUESDAY:
			return weekDays.tuesday;
		case WEEK_DAYS.WEDNESDAY:
			return weekDays.wednesday;
		case WEEK_DAYS.THURSDAY:
			return weekDays.thursday;
		case WEEK_DAYS.FRIDAY:
			return weekDays.friday;
		case WEEK_DAYS.SATURDAY:
			return weekDays.saturday;
		case WEEK_DAYS.SUNDAY:
			return weekDays.sunday;
		default:
			return weekDay;
	}
};

export {parseWeekDay, WEEK_DAYS};
